
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[nameId]",
      function () {
        return require("private-next-pages/community/[nameId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[nameId]"])
      });
    }
  